import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { injectIntl, intlShape } from 'react-intl';
import { number, string, object } from 'prop-types';

import { FieldTimePicker } from '../../components';

import css from './FieldTimeRangePicker.css';

const FieldTimeRangePicker = props => {
  const {
    className,
    rootClassName,
    idStart,
    idEnd,
    nameStart,
    nameEnd,
    label,
    minHourBetween,
    minuteStep,
    minHour,
    maxHour,
    currentValues,
    intl,
  } = props;

  const [maxHourStart, setMaxHourStart] = useState(currentValues[idEnd].hour - minHourBetween);
  const [minHourEnd, setMinHourEnd] = useState(currentValues[idStart].hour + minHourBetween);

  useEffect(() => {
    setMaxHourStart(currentValues[idEnd].hour - minHourBetween);
    setMinHourEnd(currentValues[idStart].hour + minHourBetween);
  }, [currentValues, maxHourStart, minHourEnd]);

  const fromText = intl.formatMessage({ id: 'FieldTimeRangePicker.from' });
  const toText = intl.formatMessage({ id: 'FieldTimeRangePicker.to' });

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <label className={css.label}>{label}</label>
      <div className={css.inputContainer}>
        <span className={css.from}>{fromText}</span>
        <FieldTimePicker
          id={idStart}
          name={nameStart}
          minuteStep={minuteStep}
          minHour={minHour}
          maxHour={maxHourStart}
        />
        <span className={css.to}>{toText}</span>
        <FieldTimePicker
          id={idEnd}
          name={nameEnd}
          minuteStep={minuteStep}
          minHour={minHourEnd}
          maxHour={maxHour}
        />
      </div>
    </div>
  )
}

FieldTimeRangePicker.defaultProps = {
  className: null,
  minHourBetween: 1,
  minuteStep: 1,
};

FieldTimeRangePicker.propTypes = {
  className: string,
  rootClassName: string,
  idStart: string,
  idEnd: string,
  nameStart: string,
  nameEnd: string,
  label: string,
  minHourBetween: number,
  minuteStep: number,
  minHour: number,
  maxHour: number,
  currentValues: object,

  intl: intlShape.isRequired,
};

export default injectIntl(FieldTimeRangePicker);


// WEBPACK FOOTER //
// ./src/components/FieldTimeRangePicker/FieldTimeRangePicker.js